import type {ReactElement} from 'react';
import React from 'react';
import {Checkbox} from '@Components/checkbox/checkbox';
import {CheckboxSize} from '@Components/checkbox/checkbox.types';
import {Text, TextSize} from '@Components/text';
import type {VoidFunction} from '@Components/login-page/login-page.types';
import styles from './email-update-notifications.module.scss';
import {AuthTestId} from '@/test-ids/auth-test-id';

interface EmailUpdateNotificationsProps {
  onCheckboxClick: VoidFunction;
  emailUpdates: boolean;
  disabled?: boolean;
}

function EmailUpdateNotifications({onCheckboxClick, emailUpdates, disabled = false}: EmailUpdateNotificationsProps): ReactElement {
  return (
    <label className={`${styles.notifyRow} ${disabled ? styles.disabledRow : ''}`}>
      <Checkbox isChecked={emailUpdates} isDisabled={disabled} onChange={onCheckboxClick} size={CheckboxSize.SM} data-testid={AuthTestId.NOTIFY_PROMOTIONS_CHECKBOX} />
      <Text className={styles.notifyText} size={TextSize.MD} val={window.i18next.t('pmwjs_notify_promotions')} />
    </label>
  );
}

export default React.memo(EmailUpdateNotifications);
